import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Modal, Radio} from "antd";
import {
    ModalContainer,
    ReasonTitle,
    ReasonOptionsContainer,
    ReasonOption,
    ButtonContainer,
    CancelButton,
    ConfirmButton,
    OtherReasonInput
} from "./RequestCloseReasonModal.styles";

const RequestCloseReasonModal = ({visible, onClose, onConfirm, loading = false}) => {
    const {t} = useTranslation();
    const [selectedReason, setSelectedReason] = useState(null);
    const [otherReasonText, setOtherReasonText] = useState("");

    const closeReasons = [
        "Başka bir firma ile anlaştım",
        "Süreç uzun sürdü/Süreçte problem yaşadım",
        "İhtiyacım kalmadı",
        "Talebi yanlışlıkla açtım",
        "Diğer"
    ];

    const lastReason = closeReasons[closeReasons.length - 1]; // "Diğer"

    const handleReasonChange = e => {
        setSelectedReason(e.target.value);
        if (e.target.value !== lastReason) {
            setOtherReasonText("");
        }
    };

    const handleConfirm = () => {
        if (selectedReason) {
            const reasonData = {
                reasons: [selectedReason],
                otherReason: selectedReason === lastReason ? otherReasonText : null
            };
            onConfirm(reasonData);
        }
    };

    const handleCancel = () => {
        setSelectedReason(null);
        setOtherReasonText("");
        onClose();
    };

    const isOtherSelected = selectedReason === lastReason;
    const isConfirmDisabled =
        !selectedReason || (isOtherSelected && !otherReasonText.trim()) || loading;

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={handleCancel}
            footer={null}
            width={400}
            centered
            style={{borderRadius: "10px"}}
            bodyStyle={{padding: "24px", borderRadius: "10px"}}
        >
            <ModalContainer>
                <ReasonTitle>{t("screens.customerRequests.selectReason")}</ReasonTitle>

                <ReasonOptionsContainer>
                    <Radio.Group
                        value={selectedReason}
                        onChange={handleReasonChange}
                        style={{width: "100%"}}
                    >
                        {closeReasons.map(reason => (
                            <ReasonOption key={reason}>
                                <Radio value={reason}>{reason}</Radio>
                            </ReasonOption>
                        ))}
                    </Radio.Group>
                </ReasonOptionsContainer>

                {isOtherSelected && (
                    <OtherReasonInput
                        placeholder={t("screens.customerRequests.otherReasonPlaceholder")}
                        value={otherReasonText}
                        onChange={e => setOtherReasonText(e.target.value)}
                        rows={3}
                    />
                )}

                <ButtonContainer>
                    <CancelButton onClick={handleCancel}>{t("actions.cancel")}</CancelButton>
                    <ConfirmButton onClick={handleConfirm} disabled={isConfirmDisabled}>
                        {loading ? t("actions.loading") : t("actions.confirm")}
                    </ConfirmButton>
                </ButtonContainer>
            </ModalContainer>
        </Modal>
    );
};

export default observer(RequestCloseReasonModal);
